// const projectCollection = [
//    {
//       projectImage: 'https://res.cloudinary.com/dahgxnpog/image/upload/v1723153783/homepage_zlsem9.png',
//       projectName: "PrimeMarket 🛒",
//       id: "primemarket",
//       // projectDesc: "<h1>PrimeMarket</h1> is a comprehensive e-commerce platform designed and developed over a span of more than two months. It is built using the MERN stack (MongoDB, Express, React, Node.js) and aims to provide a user-friendly online shopping experience with a focus on functionality and responsiveness.",
//       projectDesc: "<div><p>An all-in-one e-commerce solution designed for startups. <strong>PrimeMarket</strong> is a scalable and secure online store platform that delivers a seamless shopping experience. Key features include:</p><p>Role-Based Authentication, Advanced Filtering, Real-Time Checkout, and more...</p></div>",
//       projectTech: ["CSS ", "React","NodeJs","ExpressJs","MongoDB","Docker","Cloudinary", "Cypress", "Jest", "Vitest"],
//       projectType: "A Fullstack MERN E-commerce Application",
//       GitHuB: 'https://github.com/ProgrammingInsider/PrimeMarket-E-commerce-Platform',
//       Demo: 'https://primemarket.onrender.com/',
//       // Design: 'https://dribbble.com/shots/24190582-Web-Design-For-Software-Development-and-Graphics-Design?utm_source=Clipboard_Shot&utm_campaign=Amanuel_Abera&utm_content=Web%20Design%20For%20Software%20Development%20and%20Graphics%20Design&utm_medium=Social_Share&utm_source=Clipboard_Shot&utm_campaign=Amanuel_Abera&utm_content=Web%20Design%20For%20Software%20Development%20and%20Graphics%20Design&utm_medium=Social_Share',
//       DockerImage: 'https://hub.docker.com/u/aman2208'
//    },
//    {
//       projectImage: 'https://res.cloudinary.com/dahgxnpog/image/upload/v1735589031/home_blog_svqy9x.png',
//       projectName: "Blogger ✍️",
//       id: "blog",
//       projectDesc: "<div><p>A fast, dynamic platform for creating and managing blogs. Built for creators, it offers Easy Sign-Up, Tagging, Admin Control, Reader Interactions, and Speed Optimization with TailwindCSS and Vercel.</p></div>",
//       projectTech: ["Nextjs ", "TailwindCSS","Prisma","MongoDB","Cloudinary"],
//       projectType: "A Fullstack Multi-User Blog Platform",
//       GitHuB: 'https://github.com/ProgrammingInsider/Multi-User-Blog-Platform',
//       Demo: 'https://blogger-prod.vercel.app/',
//       // DockerImage: 'https://hub.docker.com/u/aman2208'
//    }
// ]

// export default projectCollection;

const projectCollection = [
  {
    projectImage:
      'https://res.cloudinary.com/dahgxnpog/image/upload/v1791137266/gymflow-homepage_gfsucp.png',
    projectName: 'GymFlow 🏋️',
    id: 'gymflow',
    projectDesc:
      '<div><p>A multi-tenant gym management SaaS for managing members, memberships, billing, staff, branches, and attendance.</p><p>Key features include multi-branch management, role-based access control, membership and billing workflows, and ZKTeco attendance integration.</p><p>GymFlow is a real-world SaaS product used by a paying gym customer.</p></div>',
    projectTech: [
      'React',
      'TypeScript',
      'NodeJs',
      'NestJS',
      'PostgreSQL',
      'TypeORM',
      'Docker',
    ],
    projectType: 'A Multi-Tenant Gym Management SaaS',
    GitHuB: '',
    Demo: '',
  },
  {
    projectImage:
      'https://res.cloudinary.com/dahgxnpog/image/upload/v1723153783/homepage_zlsem9.png',
    projectName: 'PrimeMarket 🛒',
    id: 'primemarket',
    projectDesc:
      '<div><p>An all-in-one e-commerce platform designed to provide a complete online shopping experience.</p><p>Key features include role-based authentication, product management, advanced filtering, cart and checkout workflows, order management, and automated testing.</p></div>',
    projectTech: [
      'React',
      'NodeJs',
      'ExpressJs',
      'MongoDB',
      'Docker',
      'Cloudinary',
      'Cypress',
      'Jest',
      'Vitest',
    ],
    projectType: 'A Full-Stack MERN E-Commerce Application',
    GitHuB:
      'https://github.com/ProgrammingInsider/PrimeMarket-E-commerce-Platform',
    Demo: 'https://primemarket.onrender.com/',
    DockerImage: 'https://hub.docker.com/u/aman2208',
  },
  {
    projectImage:
      'https://res.cloudinary.com/dahgxnpog/image/upload/v1735589031/home_blog_svqy9x.png',
    projectName: 'Blogger ✍️',
    id: 'blog',
    projectDesc:
      '<div><p>A multi-user blogging platform for creating, managing, and publishing content.</p><p>Key features include user authentication, tagging, admin controls, reader interactions, and a responsive interface built with modern web technologies.</p></div>',
    projectTech: ['Nextjs', 'TailwindCSS', 'Prisma', 'MongoDB', 'Cloudinary'],
    projectType: 'A Full-Stack Multi-User Blog Platform',
    GitHuB: 'https://github.com/ProgrammingInsider/Multi-User-Blog-Platform',
    Demo: 'https://blogger-prod.vercel.app/',
  },
];

export default projectCollection;
